import axios from '@/zenky'

export default {
  namespaced: true,

  state: {
    // `null` when it's neither loading nor loaded, Promise when loading, array when loaded.
    addresses: null,
  },

  mutations: {
    set(state, addresses) {
      state.addresses = addresses;
    },
  },

  actions: {
    async load({ commit, getters }, authToken) {
      if (!authToken) { // Just a hint that the user must be authenticated.
        throw new Error('The user must be authenticated in order to load saved addresses');
      }

      const req = axios.get('profile/addresses', { params: { count: 999, page: 1 } });

      let resolveLoadPromise, rejectLoadPromise;

      const loadPromise = new Promise((resolve, reject) => {
        resolveLoadPromise = resolve;
        rejectLoadPromise = reject;
      });

      commit('set', loadPromise);

      let res;

      try {
        res = await req;
      } catch (err) {
        rejectLoadPromise(err);

        commit('set', null);

        throw err;
      }

      const addresses = res.data.data

      resolveLoadPromise(addresses)

      commit('set', addresses)

      return addresses;
    },
  },
}
